import { Grid } from "@mui/material";
import CardActions from "src/pages/sistema/components/CardActions";
import { FieldView, SectionBox } from "src/pages/sistema/components/FieldView";
import { dateFormatter } from "src/utils/formatters";
import { OperacionLEPFields } from '../types/fields';
import { OperacionLEP } from "../types/types";

type SeccionLepDatosOperacionProps = {
  operacion?: OperacionLEP;
}

const SeccionLEPDatosOperacion = ({ operacion }: SeccionLepDatosOperacionProps) => {
  return (
    <CardActions title='Datos Operación' icon='mdi:briefcase-outline' colapsable>
      {operacion && (
        <SectionBox>
          <Grid item xs={12} md={3}>
            <FieldView label='País' value={operacion[OperacionLEPFields.NombrePais]} />
          </Grid>
          <Grid item xs={12} md={3}>
            <FieldView
              label='Usuario Alta'
              value={`${operacion[OperacionLEPFields.NombreUsuarioAlta]} ${operacion[OperacionLEPFields.ApellidoUsuarioAlta]}`}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <FieldView label='Unidad de Negocio' value={operacion[OperacionLEPFields.UnidadNegocio]} />
          </Grid>
          <Grid item xs={12} md={3}>
            <FieldView label='Equipo Comercial' value={operacion[OperacionLEPFields.SectorComercial]} />
          </Grid>
          <Grid item xs={12} md={3}>
            <FieldView
              label='Fecha Solicitud'
              value={dateFormatter.toShortDate(operacion[OperacionLEPFields.FechaAprobacion])}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <FieldView
              label='Fecha Vencimiento'
              value={operacion[OperacionLEPFields.FechaVencimiento]
                ? dateFormatter.toShortDate(operacion[OperacionLEPFields.FechaVencimiento])
                : undefined}
            />
          </Grid>
        </SectionBox>
      )}
    </CardActions>
  );
}

export default SeccionLEPDatosOperacion;